import React from "react";
import logo from "../assets/logo.png";
const Header = ({ activeView, setActiveView, onLogout }) => {
  return (
    <header className="header">
      <div className="header-content">
        <div className="7">
          <img src={logo} alt="Logo" className="logo" />
          <h1>Admin viewStruct</h1>
        </div>

        <nav className="nav-menu">
          <button
            className={`nav-btn ${activeView === "dashboard" ? "active" : ""}`}
            onClick={() => setActiveView("dashboard")}
          >
            <span>📊</span> Dashboard
          </button>

          <button
            className={`nav-btn ${activeView === "organizations" ? "active" : ""}`}
            onClick={() => setActiveView("organizations")}
          >
            <span>🏢</span> Organizations
          </button>

          <button
            className={`nav-btn ${activeView === "employees" ? "active" : ""}`}
            onClick={() => setActiveView("employees")}
          >
            <span>👥</span> Employees
          </button>

          <button
            className={`nav-btn ${activeView === "roles" ? "active" : ""}`}
            onClick={() => setActiveView("roles")}
          >
            <span>👔</span> Roles
          </button>
          {onLogout && (
            <button
              type="button"
              className="nav-btn"
              onClick={onLogout}
              style={{ marginLeft: "auto" }}
            >
              <span>🚪</span> Logout
            </button>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;
